import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_TRIP_EXPENSE,
  CLEAR_TRIP_EXPENSES,
  FLAG_TRIP_EXPENSE_ACTIVITY,
  FLAG_GETTING_TRIP_EXPENSES,
  GET_TRIP_EXPENSE,
  GET_TRIP_EXPENSES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_TRIP_EXPENSES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_TRIP_EXPENSES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_TRIP_EXPENSES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_TRIP_EXPENSE_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_TRIP_EXPENSE:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_TRIP_EXPENSE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
